import React, { useState, useReducer } from "react"
import { Box } from "@material-ui/core"
import UserAccordion from "./UserAccordion"
import useStyles from "./styles"

const CommunicationTextAccordion = ({
  userGroups,
  userGroupDispatch,
  handleExpand,
  expanded
}) => {
  const classes = useStyles()

  const handleCheck = (groupKey, id) => () => {
    userGroupDispatch({
      type: "SELECT_USERS",
      data: { groupKey: groupKey, selected: id }
    })
  }

  const handleSelectAll = groupKey => () => {
    userGroupDispatch({
      type: "SELECT_ALL",
      data: { groupKey }
    })
  }

  return (
    <Box>
      {Object.keys(userGroups).map(key => {
        const group = userGroups[key]
        if (!group.users.length) {
          return
        }
        return (
          <UserAccordion
            key={key}
            groupKey={key}
            groupName={group.groupName}
            users={group.users}
            selected={group.selected}
            allSelected={group.allSelected}
            handleExpand={handleExpand}
            expanded={expanded}
            handleCheck={handleCheck}
            handleSelectAll={handleSelectAll}
          />
        )
      })}
    </Box>
  )
}

export default CommunicationTextAccordion



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/CommunicationTextAccordion/index.jsx